import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, AlertController, ToastController, ModalController, LoadingController, ViewController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import { PopupPage } from '../../popup/popup';
import * as moment from 'moment';




/**
 * Generated class for the CalcdistancePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var google;
declare var ol;


@Component({
  selector: 'page-calcdistance',
  templateUrl: 'calcdistance.html',
})
export class CalcdistancePage {
  loadDataCalculate = false;
  tmpGoran = 1
  haveMechanizacija: boolean = false
  inEditMode: boolean = false

  routingTab: string = 'newroute'
  selectedVehicleName = '--- ' + this.dic.l["choosevehicle"] + ' ---';
  selectedVehicleID = -1;
  selectedVehicleNameRep = '--- ' + this.dic.l["choosevehicle"] + ' ---';
  selectedVehicleIDRep = -1;

  startDate: any = new Date()
  startDateStr: any = moment(new Date()).format(this.gn.user.DFormat)

  startDateA: any = new Date()
  startDateStrA: any = moment(new Date()).format(this.gn.user.DFormat)
  startDateB: any = new Date()
  startDateStrB: any = moment(new Date()).format(this.gn.user.DFormat)

  selectedTime = new Date().getHours() + 1 + ":00";
  selectedDriver = '--- ' + this.dic.l["ChooseDriverR"] + ' ---';
  selectedCoDrivers = '--- ' + this.dic.l["ChooseCoDriversR"] + ' ---';
  selectedDriverIds = []
  selectedCoDriversIds = []
  selectedBreak = '--- Изберете пауза ---';
  selectedBreakIds = []

  traekti: boolean = false;
  avtopati: boolean = false;
  patarini: boolean = false;

  tipRuta: boolean = false;
  idle: any = '1';

  MapRouting: any;

  tochkiPoseta = [];
  AutoCompleteShow = false
  AutoCompleteTop = '0px'
  AutoCompleteTitle = ''
  InFocused = false
  LoadingDataSearch = false
  mapSearcData = []
  AutoCompleteState = 0
  AutoCompleteIndex = 0
  linestring = ''
  linestring2 = ''
  driverUser = '-1'



  pointCount = 2

  DriversData = []
  PathLines = []

  RouteDetails = false
  timeWithOut = ''
  _zadrzuvanje = ''
  _Distance = ''
  _totaltime = 0
  _totaltimeStr = ''
  _Pauses = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60]
  SelPauses = []
  Pauzi = []
  RouteTitle = ''
  NalogId = -1
  NalogNum = ''
  RouteTotalDistance = 0
  selectedCultureStr = ''
  selectedCultureId = 0
  selectedOperationStr = ''
  selectedOperationId = 0
  selectedMaterialStr = ''
  selectedMaterialId = 0
  selectedMechanStr = ''
  selectedMechanId = 0
  _Culture = []
  _Operation = []
  _Material = []
  _Mechan = []
  DataPredefined = []
  showReportPanel = false
  showNewRoutePanel = false
  showNewPreRoutePanel = false
  showEditRoutePanel = false
  showProgressRoutePanel = false
  showFutureRoutePanel = false
  showPrintPanel = false
  showPrintPanelPatenVehicle = false
  showPrintPanelPatenTruck = false
  showPrintPanelPatenBus = false
  _PrintNalog: any
  showLeftNew = false;
  downloadPre = false;
  loadingData = false
  loadingDataEdit = false
  //path = ''
  reportData = []
  reportDataPaten = []
  r_routeNumber = ''
  r_routeName = ''


  AutoCompleteShow2 = false
  AutoCompleteState2 = 0
  LoadingDataSearch2 = false
  mapSearcData2 = []
  selectedPoiRep: any = null
  Areas = []

  XLSDataAll = []
  arr5 = [1, 2, 3, 4];
  arr14 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
  arr9 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  idxDriver = ''
  idxCoDriver = ''

  editRouteType = '';
  shortRoute = true;
  fastRoute = true;


  // selectedVehicleName = ''
  selectedVehicleId = ''


  totaltime2 = ''
  totaldistance2 = '0'


  selectedVehicleName2 = '--- ' + this.dic.l["choosevehicle"] + ' ---';
  selectedVehicleId2 = -1;

  prob = 1

  driverid = 0

  disablebutton: boolean = false
  typeofroute = 'fastest'

  KmOrMShorterst = 'Km'
  KmOrMFastest = 'Km'

  fromreconstruction: any




  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public popoverCtrl: PopoverController, public alertCtrl: AlertController, public toastCtrl: ToastController, public modalCtrl: ModalController, public loadingCtrl: LoadingController) {
    this.selectedVehicleName = '--- ' + this.dic.l["choosevehicle"] + ' ---'
    this.fromreconstruction = this.navParams.get("reconstruction")
    console.log(this.fromreconstruction, 'this.fromreconstruction')

  }




  ionViewDidLoad() {
    this.gn.addLog(5);

    // console.log('ionViewDidLoad RoutingPage');
    this.tochkiPoseta[0] = { ispoi: 1, id: 's', name: "дестинација", ppid: 0, txt: '', lon: 0, lat: 0, marker: null }
    this.tochkiPoseta[1] = { ispoi: 1, id: 'e', name: "дестинација", ppid: 0, txt: '', lon: 0, lat: 0, marker: null }
    // this.loadMapRouting()

    if (this.gn.user.driverid + '' != '-1') {
      // this.progressRoute()
    }
  }





  changeDateString(ev: any) {
    this.startDateStr = moment(ev).format(this.gn.user.DFormat)
  }




  reorderItems(from, to) {
    // console.log(from, to)
    let element = this.tochkiPoseta[from];
    this.tochkiPoseta.splice(from, 1);
    this.tochkiPoseta.splice(to, 0, element);
  }


  loadMapRouting() {
    // console.log("POVIKUVA MAPA")
    // this.MapRouting = new google.maps.Map(document.getElementById('mapFullR'), {
    //   center: { lat: -34.397, lng: 150.644 },
    //   zoom: 8
    // });

    // var bounds = new google.maps.LatLngBounds();
    // // console.log(this.gn.Vehicles)
    // // console.log(this.gn.Vehicles)
    // for (var i = 0; i < this.gn.Vehicles.length; i++) {

    //   bounds.extend(new google.maps.LatLng(parseFloat(this.gn.Vehicles[i].lat), parseFloat(this.gn.Vehicles[i].lon)));
    // }
    // this.MapRouting.setCenter(bounds.getCenter());
    // this.MapRouting.setZoom(10)
    // // this.MapRouting.fitBounds(bounds);


    this.MapRouting.setCenter({ lat: 41.998802, lng: 21.427379 })
  }


  txtchange(_ev) {
    this.disablebutton = false

    var _txt = _ev.target.value
    var t = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
    }
    this.AutoCompleteTitle = _txt

    // if(this.tochkiPoseta[0].lat != 0){

    // }
    console.log(this.AutoCompleteTitle, 'this.AutoCompleteTitle')
    // this.AutoCompleteTitle

    // var _that = this
    if (t != '') {
      this.searchGeocode(_ev.target.value)
    } else {
      this.mapSearcData = []
      this.AutoCompleteState = 0
      // console.log (_that.mapSearcData)
    }
  }

  searchGeocode(txt) {
    txt = txt.toLowerCase()
    // txt = txt.replace(/ /g,'%')
    //console.log(txt)
    if (txt == '') {
      this.mapSearcData = []
      this.AutoCompleteState = 0
      return
    }
    var _that = this
    var _lon = 21.427379
    var _lat = 41.998802
    this.LoadingDataSearch = true
    _that.AutoCompleteState = 1
    this.gn.Socket.emit({ query: txt, lon: _lon, lat: _lat, clientid: this.gn.user.ClientId }, function (_data) {
      _that.mapSearcData = _data
      _that.LoadingDataSearch = false
      if (_data.length == 0) {
        _that.AutoCompleteState = 2
      } else {
        _that.AutoCompleteState = 1
      }
      // console.log (_that.mapSearcData)
    }, 'getgeocode2')
  }
  openAutocomplete(_ev, _idx) {
    this.AutoCompleteIndex = _idx
    this.mapSearcData = []
    this.LoadingDataSearch = false
    this.AutoCompleteState = 0
    this.InFocused = true
    var _txt = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
      this.AutoCompleteState = 0
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
      this.AutoCompleteState = 1
    }
    this.searchGeocode(_ev.target.value)
    this.AutoCompleteTitle = _txt
    var _top = _ev.target.parentNode.parentNode.parentNode.parentNode.parentNode.offsetTop
    this.AutoCompleteShow = true
    this.AutoCompleteTop = (_top + 71) + 'px'
  }
  hideAutocomplete() {
    this.InFocused = false
    var _that = this
    setTimeout(function () {
      if (_that.InFocused == false) {
        _that.AutoCompleteShow = false
      }
    }, 150)
    // this.AutoCompleteShow = false
  }


  doitemACClick(_itm) {
    // console.log(_itm)
    // group: "Скопје"
    // lat: "42.002795"
    // lon: "21.458244"
    // name: "16 Makedonska brigada"
    // ppid: 0
    // type: "gc"
    this.AutoCompleteShow = false
    this.tochkiPoseta[this.AutoCompleteIndex].txt = _itm.name
    this.tochkiPoseta[this.AutoCompleteIndex].lon = _itm.lon
    this.tochkiPoseta[this.AutoCompleteIndex].lat = _itm.lat
    this.tochkiPoseta[this.AutoCompleteIndex].ispoi = _itm.ispoi

    if (this.tochkiPoseta[this.AutoCompleteIndex].marker != null) {
      for (var i = 0; i < this.Areas.length; i++) {
        if (this.Areas[i].id == this.tochkiPoseta[this.AutoCompleteIndex].ppid) {
          this.Areas[i].setMap(null)
          this.Areas.splice(i, 1);
        }
      }
    }

    this.tochkiPoseta[this.AutoCompleteIndex].ppid = _itm.ppid

    if (this.tochkiPoseta[this.AutoCompleteIndex].marker != null) {
      this.tochkiPoseta[this.AutoCompleteIndex].marker.setMap(null)
      this.tochkiPoseta[this.AutoCompleteIndex].marker = null
    }
    var img = 'assets/imgs/pin-blue.png'
    if (this.AutoCompleteIndex == 0) { img = 'assets/imgs/pin-green.png' }
    if (this.AutoCompleteIndex == this.tochkiPoseta.length - 1) { img = 'assets/imgs/pin-red.png' }


    var markerIcon = {
      url: img,
      scaledSize: new google.maps.Size(27, 43),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(14, 43),
      labelOrigin: new google.maps.Point(13, 15)
    };

    this.tochkiPoseta[this.AutoCompleteIndex].marker = new google.maps.Marker({
      position: { lat: parseFloat(_itm.lat), lng: parseFloat(_itm.lon) },
      map: this.MapRouting,
      icon: markerIcon, //'assets/imgs/pin-blue.png',
      label: {
        text: (parseInt(this.AutoCompleteIndex + '') + 1) + '',
        color: "#fff",
        fontSize: "14px",
        fontWeight: "bold",
      },
    });
    // this.MapRouting.panTo(new google.maps.LatLng(parseFloat(_itm.lat), parseFloat(_itm.lon)));
    // this.MapRouting.setZoom(15)

    if (_itm.type != 'poi') {
      var _that = this
      this.gn._Post('/api/gn/getonezone', { zid: this.gn.crypt(_itm.ppid) }, function (_data) {
        // console.log(_data[0])
        for (var i = 0; i < _data.length; i++) {
          // console.log()
          var _pois = _data[i].pois.split(",")
          var pp = []
          for (var j = 0; j < _pois.length; j++) {
            var tmp = _pois[j].split(' ')
            pp.push({ lon: parseFloat(tmp[1]), lat: parseFloat(tmp[0]) })
          }
          // console.log(_data[i].color, pp, _data[i].name)
          // var idx = _that.drawPoly(_data[i].color, pp, _data[i].name, _id)
          // _that.tempZones[_id + ''] = { data: _data, index: idx }
          // _that.CenterMap2thisPois(pp)
          // _that.drawPoly(_data[i].color, pp, _data[i].name, _itm.ppid)
        }
      })
    }
    // = {id:'s',name:"дестинација", ppid: 0, txt: '', lon: 0, lat: 0}  
  }

  itemACClick(_itm) {
    if (_itm.lon + '' == '0' && _itm.lat + '' == '0') {
      var _that = this;
      this.gn.Socket.emit({ locationid: _itm.sid }, function (_data) {
        _itm.lon = _data[0].lon
        _itm.lat = _data[0].lat
        _that.doitemACClick(_itm)
      }, 'getll0')
    } else {
      this.doitemACClick(_itm)
    }
  }

  // drawPoly(_color, _pois, _title, _id) {
  //   // console.log('drawPoly', _color, _pois, _title)
  //   var _pp = []
  //   for (var i = 0; i < _pois.length; i++) {
  //     _pp.push({ lat: _pois[i].lat, lng: _pois[i].lon })
  //   }
  //   var _poly = new google.maps.Polygon({
  //     paths: _pp,
  //     strokeColor: _color,
  //     strokeOpacity: 0.8,
  //     strokeWeight: 2,
  //     fillColor: _color,
  //     fillOpacity: 0.35,
  //     id: _id
  //   });
  //   var hasArea = false;
  //   for (var j = 0; j < this.Areas.length; j++) {
  //     if (this.Areas[j].id == _id)
  //       hasArea = true;
  //   }
  //   if (!hasArea) {
  //     _poly.setMap(this.MapRouting)
  //     this.Areas.push(_poly)
  //   }
  //   // console.log(this.historyMap)

  //   //alert(this.Areas.length + ' * ' + this.tochkiPoseta.length)
  //   // _poly.AreaName = _title
  //   // _poly.AreaId = _zoneid
  //   // _poly.AreaColor = _color
  // }



  drawLine(_points) {
    var _Line = new google.maps.Polyline({
      path: _points,
      strokeColor: '#5075b1',
      strokeOpacity: 1,
      strokeWeight: 4
    });
    _Line.setMap(this.MapRouting)
    this.PathLines.push(_Line)
  }
  ClearLine() {
    this.RouteDetails = false
    for (var i = 0; i < this.PathLines.length; i++) {
      this.PathLines[i].setMap(null)
      this.PathLines[i] = null
    }
    this.PathLines = []
  }
  showHideRouteLine(_type, _cbtxt) {
    var cb1 = this.navParams.get("callback1")

    if (_type == 'short') {
      if (cb1 != null) {
        cb1(_type, this.shortRoute);
        this.shortRoute = !this.shortRoute;
      }
      // if(this.shortRoute)
      //   this.PathLines[0].setMap(null)
      // else
      //   this.PathLines[0].setMap(this.MapRouting)
      //this.shortRoute = !this.shortRoute;
    }
    if (_type == 'fast') {
      if (cb1 != null) {
        cb1(_type, this.fastRoute);
        this.fastRoute = !this.fastRoute;
      }
      // if(this.fastRoute)
      //   this.PathLines[1].setMap(null)
      // else
      //   this.PathLines[1].setMap(this.MapRouting)
      //this.fastRoute = !this.fastRoute;
    }
  }
  numberWithCommas = (x) => {
    if (x != null)
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    else
      return x;
  }
  sec2str2(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }
  sec2str3(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  formatSec(_sec) {
    // console.log(_sec)
    var date = new Date(null); date.setSeconds(_sec);
    var result = date.toISOString().substr(11, 8);
    return result
  }
  isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  CalculateRoute() {
    this.ClearLine();
    this.totaldistance2 = '0';
    // this.ClearLine()

    var _pts = []
    var _that = this
    for (var i = 0; i < this.tochkiPoseta.length; i++) {
      if (this.tochkiPoseta[i].lat != 0) {
        _pts.push({ lon: this.tochkiPoseta[i].lon, lat: this.tochkiPoseta[i].lat })
      }
    }
    // console.log(_pts, '_pts')
    if (_pts.length < 2) {
      // MSG: Mora da imate barem dve tocki vneseno
      const alert = this.alertCtrl.create({
        subTitle: this.dic.l["routeinfo2"],
        buttons: [this.dic.l['ok']]
      });
      alert.present();

      return
    } else {
      var _optimum = 'shortest'
      var _TollRoad = "no";
      var _Highways = "no";
      var _Ferry = "no";

      this.loadDataCalculate = true;
      this.gn.Socket.emit({ routeby: this.gn.clientsettings.routeby, cid: this.gn.user.ClientId, uid: this.gn.user.UserId, points: _pts, TollRoad: _TollRoad, Highways: _Highways, Ferry: _Ferry, Type: _optimum, Unit: "k" }, function (_data) {
        _that.gn.Socket.emit({ routeby: _that.gn.clientsettings.routeby, cid: _that.gn.user.ClientId, uid: _that.gn.user.UserId, points: _pts, TollRoad: _TollRoad, Highways: _Highways, Ferry: _Ferry, Type: 'fastest', Unit: "k" }, function (_data2) {

          _that.loadDataCalculate = false;

          var _pp = []
          var _pp2 = []

          var _pposm = []
          var _pposm2 = []

          _that.linestring2 = 'LINESTRING ('

          for (var i = 0; i < _data2.routes.length; i++) {
            var _route2 = _data2.routes[i]
            for (var j = 0; j < _route2.points.length; j++) {
              _that.linestring2 += parseFloat(_route2.points[j].lng) + ' ' + parseFloat(_route2.points[j].lat) + ', ';
              _pp2.push({ lat: parseFloat(_route2.points[j].lat), lng: parseFloat(_route2.points[j].lng) })
              _pposm2.push(ol.proj.transform([_route2.points[j].lng, _route2.points[j].lat], 'EPSG:4326', 'EPSG:900913'))

            }
          }
          _that.linestring2 = _that.linestring2.substring(0, _that.linestring2.length - 2)
          _that.linestring2 += ')'






          var bounds = new google.maps.LatLngBounds();
          _that.linestring = 'LINESTRING ('
          for (var i = 0; i < _data.routes.length; i++) {
            var _route = _data.routes[i]
            for (var j = 0; j < _route.points.length; j++) {
              _that.linestring += parseFloat(_route.points[j].lng) + ' ' + parseFloat(_route.points[j].lat) + ', ';
              _pp.push({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) })
              _pposm.push(ol.proj.transform([_route.points[j].lng, _route.points[j].lat], 'EPSG:4326', 'EPSG:900913'))
              bounds.extend({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) });
            }
          }
          _that.linestring = _that.linestring.substring(0, _that.linestring.length - 2)
          _that.linestring += ')'
          // debugger
          // if (_data.distance <= 1) {
          //   _that.KmOrMShorterst = 'M'
          // }

          // if (_data2.distance <= 1) {
          //   _that.KmOrMFastest = 'M'
          // }


          _that._Distance = parseFloat(_data.distance).toFixed(1)
          _that._totaltime = parseInt(_data.time)

          _that.totaltime2 = _that.formatSec(parseInt(_data2.time))
          _that.totaldistance2 = parseFloat(_data2.distance).toFixed(1)
          // console.log(this.RouteTotalDistance, _data.distance)
          _that._totaltimeStr = _that.formatSec(_that._totaltime)

          var cb = _that.navParams.get("callback")
          if (cb != null) {
            cb(_pp, bounds, _pp2, _pposm, _pposm2, 0)
          }
          _that.disablebutton = true
          _that.RouteDetails = true
        }, 'getDirections')

      }, 'getDirections')


    }

  }

  // ionViewWillLeave() {
  //   debugger
  // }


  // ionViewDidLeave() {
  //   debugger
  //   // this.close()
  // }

  // ionViewWillUnload() {
  //   debugger
  // }


  // close2() {
  //   this.viewCtrl.dismiss();
  // }

  close() {
    var cb = this.navParams.get("callback")
    if (cb != null) {
      cb([], [], [], [], [], 1)
    }
    this.navCtrl.pop()
  }


  openAutocomplete2(_ev) {

    this.mapSearcData2 = []
    this.LoadingDataSearch2 = false
    this.AutoCompleteState2 = 0

    this.InFocused = true
    var _txt = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
      this.AutoCompleteState2 = 0
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
      this.AutoCompleteState2 = 1
    }
    this.searchGeocode2(_ev.target.value)
    // this.AutoCompleteTitle2 = _txt
    // var _top = _ev.target.parentNode.parentNode.parentNode.parentNode.parentNode.offsetTop
    this.AutoCompleteShow2 = true
    // this.AutoCompleteTop = (_top + 71) + 'px'
  }
  hideAutocomplete2() {
    if (this.r_routeName == '') { this.selectedPoiRep = null }
    this.InFocused = false
    var _that = this
    setTimeout(function () {
      if (_that.InFocused == false) {
        _that.AutoCompleteShow2 = false
      }
    }, 150)
    // this.AutoCompleteShow = false
  }
  txtchange2(_ev) {
    this.disablebutton = false

    var _txt = _ev.target.value
    var t = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
    }



    // this.AutoCompleteTitle = _txt


    // var _that = this
    if (t != '') {
      this.searchGeocode2(_ev.target.value)
    } else {
      this.mapSearcData2 = []
      this.AutoCompleteState2 = 0
      // console.log (_that.mapSearcData)
    }
  }
  searchGeocode2(txt) {
    txt = txt.toLowerCase()
    // txt = txt.replace(/ /g,'%')
    // console.log(txt)
    if (txt == '') {
      this.mapSearcData2 = []
      this.AutoCompleteState2 = 0
      return
    }
    var _that = this
    var _lon = this.MapRouting.getCenter().lng()
    var _lat = this.MapRouting.getCenter().lat()
    this.LoadingDataSearch2 = true
    _that.AutoCompleteState2 = 1
    this.gn.Socket.emit({ query: txt, lon: _lon, lat: _lat, clientid: this.gn.user.ClientId }, function (_data) {
      //  console.log(_data)
      _that.mapSearcData2 = []
      for (var i = 0; i < _data.length; i++) {
        if (_data[i].ppid + '' != '0') {
          _that.mapSearcData2.push(_data[i])
        }
      }

      _that.LoadingDataSearch2 = false
      if (_that.mapSearcData2.length == 0) {
        _that.AutoCompleteState2 = 2
      } else {
        _that.AutoCompleteState2 = 1
      }
      // console.log (_that.mapSearcData)
    }, 'getgeocode1')
  }


  itemACClick2(_itm) {
    this.AutoCompleteShow2 = false
    this.selectedPoiRep = { txt: '', lon: 0, lat: 0, ppid: 0 }

    this.selectedPoiRep.txt = _itm.name
    this.selectedPoiRep.lon = _itm.lon
    this.selectedPoiRep.lat = _itm.lat
    this.selectedPoiRep.ppid = _itm.ppid
    this.r_routeName = _itm.name
  }




  Round(_txt) {
    return parseInt(_txt + '')
  }

  RoundFloat(_txt) {
    return parseFloat(parseFloat(_txt + '').toFixed(1));
  }
  RoundFloat1(_txt) {
    return parseFloat(parseFloat(_txt + '').toFixed(2));
  }
  RoundFloatCeil(_txt) {
    return Math.ceil(parseFloat(_txt + ''));
  }






  openVehiclePopup(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vehicles-routing', selected: [], callback: function (_text, _ids) {
        _that.disablebutton = false

        _that.selectedVehicleName = _text;
        _that.selectedVehicleId = _ids

        for (let i = 0; i < _that.gn.Vehicles.length; i++) {
          if (parseInt(_ids + '') == _that.gn.Vehicles[i].vehicleid) {
            _that.tochkiPoseta[0] = { ispoi: 1, id: 's', name: _that.gn.Vehicles[i].gis, ppid: 0, txt: _that.gn.Vehicles[i].gis, lon: _that.gn.Vehicles[i].lon, lat: _that.gn.Vehicles[i].lat, marker: null }
          }
        }

        //debugger

        _that.gn._Post('/api/gn/getvehicledriver', { vid: _that.gn.crypt(parseInt(_ids + '')) }, function (_data) {
          console.log(_data, 'daj da vidam data')
          _that.driverid = _data.id
          // this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleId]].driver
          // for (var i = 0; i < _data.length; i++) {
          //     if (_data[i].id + '' == _that.DriversData[d].id + '') {
          //       _that.DriversData[d].available = 1;
          //       // console.log('@@@' + _that.selectedDriverIds.toString())
          //       if (_that.selectedDriverIds.toString() == _that.DriversData[d].id + '')
          //         tfDriver = true;
          //     }



          // }

          // _that.selectedVehicleName = _text;
          // _that.selectedVehicleID = parseInt(_ids);
        })
      }
    })

    popover.present({
      ev: _ev
    });
  }

  openVehiclePopup2(_ev) {

    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vehicles-routing', selected: [], callback: function (_text, _ids) {
        _that.disablebutton = false

        _that.selectedVehicleName2 = _text;
        _that.selectedVehicleId2 = _ids

        for (let i = 0; i < _that.gn.Vehicles.length; i++) {
          if (parseInt(_ids + '') == _that.gn.Vehicles[i].vehicleid) {
            _that.tochkiPoseta[_that.tochkiPoseta.length - 1] = { ispoi: 1, id: 's', name: _that.gn.Vehicles[i].gis, ppid: 0, txt: _that.gn.Vehicles[i].gis, lon: _that.gn.Vehicles[i].lon, lat: _that.gn.Vehicles[i].lat, marker: null }
          }
        }
      }
    });
    popover.present({
      ev: _ev
    });
  }
  clearAp(_txt) {

    return (_txt + '').replace(/\"/g, "")
  }

  addRoute() {
    var _points = []
    for (var i = 0; i < this.tochkiPoseta.length; i++) {
      var pp = this.tochkiPoseta[i]
      if (pp.lon + '' != '0' && pp.lat + '' != '0') {
        var pnt = '{"ispoi": ' + this.clearAp(pp.ispoi) + ', "txt":"' + this.clearAp(pp.txt) + '", "lon":"' + this.clearAp(pp.lon) + '", "lat":"' + this.clearAp(pp.lat) + '", "ppid":"' + this.clearAp(pp.ppid) + '", "checked":"0"}'
        _points.push(pnt)
      }
    }

    if (_points.length < 2) {
      const alert = this.alertCtrl.create({ subTitle: this.dic.l["routeinfo2"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    //debugger
    if (this.tochkiPoseta[0].name != 'дестинација' && this.selectedVehicleId + '' != '-1') {
      //debugger
      var driverid = this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleId]].driver
      var vehicleid = this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleId]].vehicleid
      if (driverid + '' != '/') {
        var _that = this
        this.gn._Post('/api/gn/getvehicledriver', { vid: _that.gn.crypt(parseInt(vehicleid + '')) }, function (_data) {
          //debugger
          // _that.driverid = _data.id
          _that.savenalog(_data[0].driverid)
        })

      } else {
        const alert = this.alertCtrl.create({ subTitle: this.dic.l["addvehicledriverforroute"] + ' ' + this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleId]].registration, buttons: [this.dic.l['ok']] });
        alert.present();
        return
      }
    } else {
      //debugger
      var _that = this
      // this.gn._Post('/api/gn/getalldriversandvehicles', { cid: _that.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      let popover = _that.popoverCtrl.create(PopupPage, {
        type: 'alldriversandvehicles', selected: [], callback: function (_text, _ids) {
          _that.gn._Post('/api/gn/getvehicledriverfromdriverid', { did: _that.gn.crypt(_ids) }, function (_data) {
            //debugger
            // for (let pp = 0; pp < _data; pp++) {
            //   if (_ids + '' == _data[pp].driverid + '')
            //     debugger
            _that.selectedVehicleId = _data[0].vehicleid
            // }
            // _that.selectedVehicleId = _ids
            _that.savenalog(_ids)
          })
        }
      }, { cssClass: 'calcdriver-popover' })
      popover.present({
        // ev: _ev
      });

    }
  }

  savenalog(_driverId) {

    var _points = []
    for (var i = 0; i < this.tochkiPoseta.length; i++) {
      var pp = this.tochkiPoseta[i]
      if (pp.lon + '' != '0' && pp.lat + '' != '0') {
        var pnt = '{"ispoi": ' + this.clearAp(pp.ispoi) + ', "txt":"' + this.clearAp(pp.txt) + '", "lon":"' + this.clearAp(pp.lon) + '", "lat":"' + this.clearAp(pp.lat) + '", "ppid":"' + this.clearAp(pp.ppid) + '", "checked":"0"}'
        _points.push(pnt)
      }
    }

    var _that = this
    var dr1 = "0"; if (this.selectedDriverIds.length >= 1) { dr1 = this.selectedDriverIds[0] }
    //sovozaci
    var dr2 = "0"; if (this.selectedCoDriversIds.length >= 1) { dr2 = this.selectedCoDriversIds[0] }
    var dr3 = "0"; if (this.selectedCoDriversIds.length >= 2) { dr3 = this.selectedCoDriversIds[1] }
    var dr4 = "0"; if (this.selectedCoDriversIds.length >= 3) { dr4 = this.selectedCoDriversIds[2] }

    var p1 = "0"; if (this.SelPauses.length >= 1) { p1 = this.SelPauses[0] }
    var p2 = "0"; if (this.SelPauses.length >= 2) { p2 = this.SelPauses[1] }
    var p3 = "0"; if (this.SelPauses.length >= 3) { p3 = this.SelPauses[2] }
    var p4 = "0"; if (this.SelPauses.length >= 4) { p4 = this.SelPauses[3] }
    var p5 = "0"; if (this.SelPauses.length >= 5) { p5 = this.SelPauses[4] }

    var _dt = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.selectedTime

    var _pointsStr = '[' + _points.join(',') + ']'

    // ke gi preklopam shortest so fastest promenilivite

    var types = 'shortest'
    if (this.typeofroute == 'fastest') {
      this._Distance = this.totaldistance2
      this._totaltimeStr = this.totaltime2
      this.linestring = this.linestring2
      types = 'fastest'
    }

    var hCul = 0
    var _dat = {
      vid: this.gn.crypt(this.selectedVehicleId),
      driver1: this.gn.crypt(_driverId),
      driver2: this.gn.crypt(dr2),
      driver3: this.gn.crypt(dr3),
      driver4: this.gn.crypt(dr4),
      dt: this.gn.crypt(_dt),
      title: this.gn.crypt(this.RouteTitle),
      id: this.gn.crypt(this.NalogId),
      routenum: this.gn.crypt(this.NalogNum),
      cid: this.gn.crypt(this.gn.user.ClientId),
      uid: this.gn.crypt(this.gn.user.UserId),
      zad: this.gn.crypt(parseInt(this.idle)),
      Pause1: this.gn.crypt(p1),
      Pause2: this.gn.crypt(p2),
      Pause3: this.gn.crypt(p3),
      Pause4: this.gn.crypt(p4),
      Pause5: this.gn.crypt(p5),
      TotalKm: this.gn.crypt(this._Distance),
      linestring: this.gn.crypt(this.linestring),
      TotalTime: this.gn.crypt(this._totaltime),
      optimized: this.gn.crypt('optimized'),
      shortest: this.gn.crypt(types),
      culA: this.gn.crypt(this.selectedCultureId),
      culB: this.gn.crypt(this.selectedOperationId),
      culC: this.gn.crypt(this.selectedMaterialId),
      culD: this.gn.crypt(this.selectedMechanId),
      cul: this.gn.crypt(hCul),
      points: this.gn.crypt(_pointsStr),
      cnt: this.gn.crypt(_pointsStr.length),
      driveruser: this.gn.crypt(_driverId)
    }

    // this.driverUser = dr1




    var logroute = 'Нов налог: ' + (this.RouteTitle == '' ? '/' : this.RouteTitle)
    if (this.NalogId != -1) {
      logroute = 'Промена на налог: ' + this.NalogId
    }
    var vida = [];
    vida.push(this.selectedVehicleId);
    this.gn.addLog(38, logroute);
    this.gn.loadWaiting();


    this.gn._Post('/api/gn/saveroute', _dat, function (_data) {

      _that.gn.loaderWaiting.dismiss();

      console.log(_data, 'sto se slucuva')


      if (_data.checkformesss == 'ok1') {
        var dat2 = {
          fromuid: _that.gn.crypt(_that.gn.user.UserId),
          touid: _that.gn.crypt(_driverId),
          message: _that.gn.crypt('#routetodriver#' + _data.nalid),
          messnotification: _that.gn.crypt(_that.dic.l["newroute"] + ': ' + _data.nalid)

        }
        _that.gn._Post('/api/gn/createMessageFromRouteRegular', dat2, function (_data2) {
        })
      }
      const alert = _that.alertCtrl.create({ subTitle: _that.dic.l["SaveOrderDone"], buttons: [_that.dic.l['ok']] });
      alert.present();
    })
  }



  // addTochka() {
  //   this.tochkiPoseta.push({ ispoi: 1, id: 'm', name: "локација", ppid: 0, txt: '', lon: 0, lat: 0, marker: null, type: 0 })
  //   this.reorderItems(this.tochkiPoseta.length - 2, this.tochkiPoseta.length - 1);
  //   this.pointCount = this.tochkiPoseta.length
  // this.resetMarkersOnMap()
  // let element = this.tochkiPoseta[this.tochkiPoseta.length-2];
  // console.log(element)
  // this.tochkiPoseta.splice(this.tochkiPoseta.length-2, 1);
  // this.tochkiPoseta.splice(this.tochkiPoseta.length-1, 0, element);
  // }
  deleteTochka(idx) {
    for (var i = 0; i < this.Areas.length; i++) {
      if (this.Areas[i].id == this.tochkiPoseta[idx].ppid) {
        this.Areas[i].setMap(null)
        this.Areas.splice(i, 1);
      }
    }
    if (this.tochkiPoseta[idx].marker != null) {
      this.tochkiPoseta[idx].marker.setMap(null)
      this.tochkiPoseta[idx].marker = null
    }

    this.tochkiPoseta.splice(idx, 1)
    this.pointCount = this.tochkiPoseta.length
    // this.resetMarkersOnMap()
  }




}







// WEBPACK FOOTER //
// ./src/pages/mapview/calcdistance/calcdistance.ts